import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import {NgbAccordionConfig} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  providers: [NgbAccordionConfig]
})
export class FaqComponent implements OnInit {

  contents = [
    {
      question: 'Is the robot safe?',
      answer: 'Massage Robotics (MR) has designed a massage robot using Collaborative Robots (COBOTS) which meet the international standards for robot that can safely operate around humans due to their low power and programmable speed and force limitations.'
    },
    {
      question: 'Does the robot feel good?',
      answer: 'There is an endless supply of massage tools that attach to the end of the robot (end-effectors) that allow for an unlimited number of massages and therapies.'
    },
    {
      question: 'Where can I try a massage robot?',
      answer: 'We have developed a high functioning MVP and we are on schedule to release production ready units by Q2 2022.'
    },
    {
      question: 'Where can I learn more about Massage Robotics?',
      answer: 'If you still have questions after reviewing the website reach out to us through our contact page on this website and someone from Massage Robotics will reach out to you.'
    },
    {
      question: 'Can the robot be used for physical therapy?',
      answer: 'We are currently working with physical therapist around the world to develop rehabilitation routines that doctors can prescribe.'
    },
    {
      question: 'How does the robot know what I like?',
      answer: 'We have designed an app that allows users to create and customize routines that can be stored and modified in the cloud. These routines can be shared online and are limitless!'
    },
    {
      question: 'How can I customize a massage routine?',
      answer: 'Thanks to Google and their interest in MR you can now speak to the robot using Natural Language Processing (NLP). You can tell the robot to move in any direction with any amount of force and select from many different end-effectors.'
    },
    {
      question: 'Can the robot be networked together for spas and resorts around the world?',
      answer: 'YES!'
    },
    {
      question: 'Are there any investment opportunities in MR?',
      answer: 'YES! Contact us through our website site to learn what and where MR is up to in your area.'
    }
  ];

  constructor(
    private meta: Meta,
    private title: Title,
    config: NgbAccordionConfig
  ) {
    config.closeOthers = true;
    config.type = 'myclass';
   }

  ngOnInit() {
    this.title.setTitle('Massage Robotics - Just for the feel of it');
    this.meta.updateTag({ name: 'Description', content: 'Massage Robotics' });
    this.meta.updateTag({ name: 'Keywords', content: 'Massage Robotics' });
  }
}
